import { useLocalization } from '~/framework';
import {
   getCourseCompletion,
   GetCourseCompletionErrorCode,
   getCourseCompletionFromClient,
} from '~/pages/api/courses/_shared/getCourseCompletion.api';
import { useApiErrorMessageToast } from '~/pages/_shared';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { ApiClient } from '@dozuki/web-js/dist/utils';

const KEY = 'course-completion';

export function getCourseCompletionKey(wikiid: number) {
   return [KEY, wikiid];
}

export function useCourseCompletion(wikiid: number) {
   const { _js } = useLocalization();
   const { handleErrorOrRedirectToLogin } = useApiErrorMessageToast<GetCourseCompletionErrorCode>({
      'course_assignments.get_course_completion.course_not_found': _js(
         'Could not find selected course'
      ),
      default: _js(
         "There was a problem retrieving the selected course's completion, please try again"
      ),
   });

   return useQuery({
      queryFn: async () => {
         return await getCourseCompletionFromClient(wikiid);
      },
      queryKey: getCourseCompletionKey(wikiid),
      onError: handleErrorOrRedirectToLogin,
   });
}

export async function prefetchCourseCompletion(
   wikiid: number,
   apiClient: ApiClient,
   queryClient: QueryClient
): Promise<void> {
   await queryClient.prefetchQuery(getCourseCompletionKey(wikiid), () =>
      getCourseCompletion(wikiid, { apiClient })
   );
}
